import React, { Component } from 'react';
import { connect } from 'react-redux';
import './sms.css';
import CustomLoading from '../../../util_components/custom_loading';
import ToggleSwitch from '../../../util_components/ToggleSwitch';
import { post_api, get_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import * as actions from '../../../../redux/action_creators';
import { SMSHandler } from '../../../../myt_chat/worker/chatProxies';
import moment from 'moment';
import { ChatClient } from '../../../../myt_chat/worker/chatProxies';
import ConnectionState from '../../../../myt_chat/chat/enums/ConnectionState';
import { CallbackHandler } from '../../../../myt_chat/chat/callbacks/handler';
import { SMSChannelPkt } from '../../../../myt_chat/chat/packets/SMSChannel';
import UserRole from '../../../../myt_chat/chat/enums/UserRole';
import { WhatsappIcon, SMSIcon, DOCIcon } from '../../../../utils/svg';
import PredefinedMessage from '../../../../components/views/reports/modal/PredefinedMessageModal';
import SharedMediaRenderer from './SharedMediaRenderer';
import RemindersModal from '../../reminders/RemindersModal';
import { isMobileViewport } from '../../../../utils/responsive/viewport';
import { attachKeyboardInset } from '../../../../utils/responsive/keyboardInset';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { compose_outbound_message } from '../../sales_task_list/onboarding_link';

class SmsWindow extends Component {
  messageEnd = React.createRef();

  // Root element of the full-screen panel; used to apply the mobile keyboard inset.
  windowRef = React.createRef<HTMLDivElement>();

  // Message composer textarea; auto-grows with content up to a max height.
  composerRef = React.createRef<HTMLTextAreaElement>();

  kbdCleanup?: () => void;

  constructor(props) {
    super(props);

    this.state = {
      is_loading: false,
      add_student_uuid: '',
      sms_data_of_user: [],
      // Pending scheduled messages for this student, shown as ghost bubbles
      // at the bottom of the thread until they are sent.
      scheduled_msgs: [],
      new_sms: '',
      student_name: '',
      sending_sms: false,
      timeLeft: '24:00:00',
      showTimer: false,
      messageDispatcher: '',
      replied_time: '',
      is_whatsapp: this.props.message_dispatch_method === 'whatsapp',
      predefined_msg: false,
      openImage: false,
      selected_template: null,
      // Dispatch options: quiet-hours override and schedule-for-later.
      force_instant: false,
      schedule_open: false,
      schedule_datetime: '',
      schedule_confirmed: false,
      // "Create reminder" launched from a message (when enable_reminder is set).
      reminder_open: false,
      reminder_desc: ''
    };
  }

  open_reminder = (sms: any) => {
    this.setState({ reminder_open: true, reminder_desc: sms?.sms_body || '' });
  };

  close_reminder = () => this.setState({ reminder_open: false, reminder_desc: '' });
  timerInterval: number | null = null;

  smsHandler = (item: SMSChannelPkt) => {
    console.log('smswindow->smshandler->', JSON.stringify(item));
    if (!item.channel.endsWith(this.state.add_student_uuid)) {
      return;
    }

    const smsItem = {
      uuid: item.id,
      to_student: item.to.role === UserRole.STUDENT ? 1 : 0,
      sms_timestamp: moment.utc(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
      sms_body: item.text,
      sender_name: item.from.name,
      message_type: item.from.messageSentBy || 'sms',
      status: item.status,
      sms_epoch_time: item.timestamp,
      media: item.media
    };

    const indexedElement = this.state.sms_data_of_user.find((x) => {
      return x.uuid === smsItem.uuid;
    });

    if (indexedElement !== undefined) {
      return;
    }

    const newItems = [...this.state.sms_data_of_user];

    newItems.push(smsItem);

    this.setState(
      {
        sms_data_of_user: newItems
      },
      () => {
        this.scrollToBottom();
      }
    );
  };
  componentDidMount() {
    this.setState(
      {
        add_student_uuid: this.props.student_uuid,
        student_name: this.props.student_name,
        original_message_uuid: this.props.original_message_uuid
      },
      () => {
        this.load_data();
      }
    );

    CallbackHandler.shared.registerSMSHandler(this.smsHandler);

    // Keep the composer above the on-screen keyboard on mobile (full-screen mode).
    if (isMobileViewport()) {
      this.kbdCleanup = attachKeyboardInset(() => this.windowRef.current);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.student_uuid === this.props.student_uuid) {
      return;
    }

    this.setState(
      {
        add_student_uuid: this.props.student_uuid,
        student_name: this.props.student_name,
        original_message_uuid: this.props.original_message_uuid
      },
      () => {
        this.load_data();
      }
    );
  }

  componentWillUnmount() {
    CallbackHandler.shared.unregisterSMSHandler(this.smsHandler);
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.kbdCleanup?.();
  }
  isAnyMessageSentByStudent = () => {
    const messages = this.state.sms_data_of_user || [];
    if (messages.length === 0) return false; // No messages available

    return (
      this.props.message_dispatch_method === 'whatsapp' &&
      messages.some((mess: any) => mess.to_student === 0 && mess.message_type === 'whatsapp')
    );
  };
  render_timer = () => {
    const messages = this.state.sms_data_of_user;

    const lastMessageToStudent = [...messages]
      .reverse()
      .find((msg) => msg.to_student === 0 && msg.message_type === 'whatsapp');

    let shouldShowTimer = false;

    if (lastMessageToStudent) {
      const createdTime = lastMessageToStudent.sms_epoch_time;
      const expirationTime = createdTime + 24 * 60 * 60 * 1000;
      const currentTime = Date.now();

      shouldShowTimer =
        this.props.message_dispatch_method === 'whatsapp' &&
        currentTime < expirationTime &&
        this.isAnyMessageSentByStudent();
    }

    if (!shouldShowTimer) {
      return null;
    }

    if (!this.state.is_whatsapp) {
      return null;
    }

    return (
      <div>
        <div className="border-t border-b border-[var(--state-error-bg)] bg-[var(--state-error-bg)] px-[15px] py-[14px]">
          <div className="text-[var(--state-error)] text-center font-inter text-[13px] font-medium leading-[14px]">
            Time left to reply {this.state.timeLeft}
          </div>
        </div>
      </div>
    );
  };

  load_data = () => {
    if (!!!this.state.add_student_uuid) {
      return;
    }

    this.load_scheduled_msgs();

    const connectionListener = (state: ConnectionState) => {
      if (state !== ConnectionState.AUTHENTICATED) {
        CallbackHandler.shared.registerConnectionListener(connectionListener);
        return;
      }

      CallbackHandler.shared.unregisterConnectionListener(connectionListener);

      this.setState({
        is_loading: true
      });

      SMSHandler.shared.fetchSMSArchive(this.state.add_student_uuid).then((result) => {
        let items = result.messages.map((item) => {
          return {
            uuid: item.id,
            to_student: item.toStudent ? 1 : 0,
            sms_timestamp: moment.utc(item.timestamp).format('YYYY-MM-DD HH:mm:ss'),
            sms_body: item.text,
            sender_name: item.profile.name,
            message_type: item.messageSentBy,
            status: item.status,
            sms_epoch_time: item.timestamp,
            media: item.media
          };
        });

        this.setState(
          {
            sms_data_of_user: items,
            is_loading: false
          },
          () => {
            this.startTimer();
            this.scrollToBottom();
          }
        );
      });
    };

    connectionListener(ChatClient.shared.connectionState());
  };

  send_success_notification = () => {
    try {
      this.props.send_success_notification?.();
    } catch (e) {
      console.log('smswindow->send_success_notification->', e);
    }
  };

  // Pending scheduled messages (quiet-hours deferrals + schedule-for-later)
  // for this student, shown at the bottom of the thread.
  load_scheduled_msgs = () => {
    const url = get_api_url(
      `/v2/notifications/scheduled_messages?student_uuid=${encodeURIComponent(
        this.state.add_student_uuid
      )}`,
      false,
      true
    );
    get_api(url, true)
      .then((res) => {
        this.setState({ scheduled_msgs: res?.data?.data?.scheduled_messages || [] });
      })
      .catch((e) => {
        console.log('smswindow->load_scheduled_msgs->', e);
      });
  };

  cancel_scheduled_msg = (item) => {
    if (!window.confirm('Cancel this scheduled message? It will not be sent.')) {
      return;
    }
    const url = get_api_url('/v2/notifications/scheduled_messages/cancel', false, true);
    post_api(url, { uuid: item.uuid }, true)
      .then(() => {
        this.setState((prev) => ({
          scheduled_msgs: prev.scheduled_msgs.filter((m) => m.uuid !== item.uuid)
        }));
        this.props.set_notification_variable(true, 'success', 'Scheduled message cancelled.');
      })
      .catch(() => {
        this.props.set_notification_variable(
          true,
          'error',
          'Could not cancel the scheduled message.'
        );
      });
  };

  openPredefinedMessage = () => {
    this.setState((prev) => ({
      predefined_msg: !prev.predefined_msg
    }));
  };

  closePredefinedModal = () => {
    this.setState({ predefined_msg: false, selected_template: null });
  };

  // Optional host hook (sales task form's off-hours confirm); absent = send now.
  reply_user = (message_method = 'sms', message_tag = '') => {
    if (this.state.new_sms.trim() === '' && message_tag === '') {
      return;
    }
    const before_send = this.props.before_send;
    // Scheduling isn't an immediate contact, so only immediate sends are gated.
    if (before_send && !this.state.schedule_open) {
      before_send(() => this.send_reply(message_method, message_tag), message_method);
      return;
    }
    this.send_reply(message_method, message_tag);
  };

  send_reply = (message_method = 'sms', message_tag = '') => {
    // A picked datetime counts even without the OK confirmation.
    if (this.state.schedule_open) {
      const schedule_error = this.validate_schedule_time();
      if (schedule_error) {
        this.props.set_notification_variable(true, 'error', schedule_error);
        return;
      }
    } else {
      // No explicit schedule, but the server will defer this one out of the
      // student's quiet hours — apply the same WhatsApp window cap up front so
      // the agent finds out now rather than losing the message at dispatch.
      // A confirm rather than a hard block: the server exempts US numbers
      // (they go out over SMS whatever the medium) and we can't tell the
      // region from here, so the server stays the authority on rejection.
      const quiet_hours_error = this.quiet_hours_window_error(message_tag);
      if (quiet_hours_error && !window.confirm(`${quiet_hours_error}\n\nSend anyway?`)) {
        return;
      }
    }
    this.setState({ sending_sms: true }, () => {
      let api_url = '/v2/notifications/twilio/send_message';
      const url = get_api_url(api_url, false, true);
      let payload;
      // Callers that carry a continue-onboarding link (the sales task form) ask
      // for the footer on every outbound message. The prop is absent everywhere
      // else, and the helper is a no-op without a link, so this window behaves
      // exactly as before for every other page. Template-tag sends are the
      // server's own copy, not the agent's, so they are left alone.
      payload = {
        to_student_uuid: this.state.add_student_uuid,
        // `|| this.state.new_sms` keeps the template-tag path, where an empty
        // body is legitimate because the server supplies the copy.
        message:
          compose_outbound_message(this.state.new_sms, this.props.onboarding_link) ||
          this.state.new_sms,
        sms_template_tag: message_tag,
        message_medium_type: message_method === 'whatsapp' ? 'WHATSAPP' : 'SMS',
        original_message_uuid:
          this.props.original_message_uuid != undefined ? this.props.original_message_uuid : '',
        force_send_now: this.state.force_instant,
        // Interpreted server-side in the student's local timezone.
        schedule_at:
          this.state.schedule_open && this.state.schedule_datetime
            ? `${this.state.schedule_datetime.replace('T', ' ')}:00`
            : ''
      };

      post_api(url, payload, true)
        .then((response) => {
          if (response?.data?.status === 'failure') {
            let err_message;
            try {
              if (response?.data?.code === 424) {
                err_message = 'Message too long. please reduce the size';
              } else {
                // The scheduling gates (closed WhatsApp window, misconfigured
                // template) come back here as a plain-English `reason` — show
                // it verbatim rather than a generic failure.
                err_message =
                  response?.data?.reason || 'Message not sent. Please contact dev team.';
              }
            } catch (err) {
              err_message = 'Some error occured. Please contact dev team.';
            }
            this.props.set_notification_variable(true, 'error', err_message);
            this.setState({ is_loading: false, sending_sms: false, selected_template: null });
          } else {
            const was_explicit_schedule = this.state.schedule_open && this.state.schedule_datetime;
            this.setState(
              {
                new_sms: '',
                sending_sms: false,
                predefined_msg: false,
                selected_template: null,
                force_instant: false,
                schedule_open: false,
                schedule_datetime: '',
                schedule_confirmed: false
              },
              this.autosize_composer
            );
            if (response?.data?.scheduled) {
              const at = response?.data?.scheduled_at;
              this.props.set_notification_variable(
                true,
                'success',
                was_explicit_schedule
                  ? `Message scheduled for ${at} (student local time).`
                  : `Student is in quiet hours (10 PM–8 AM their time). Message scheduled for ${at} (student local time).`
              );
            }
            this.send_success_notification();
            this.load_data();
          }
        })
        .catch((e) => {
          console.log('smswindow->reply_user->', e);
          let err_message;
          try {
            err_message =
              e.response?.data?.reason ||
              e.response?.data?.message ||
              'Some error occured. Please contact dev team.';
          } catch (err) {
            err_message = 'Some error occured. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ is_loading: false, sending_sms: false, selected_template: null });
        });
    });
  };

  onCommonChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    this.setState({ [key]: value });
  };

  autosize_composer = () => {
    const el = this.composerRef.current;
    if (!el) {
      return;
    }
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, 140)}px`;
  };

  on_composer_change = (e) => {
    this.onCommonChange(e);
    this.autosize_composer();
  };

  scrollToBottom = () => {
    try {
      setTimeout(() => {
        if (this.messageEnd.current) {
          const height = this.messageEnd.current.scrollHeight;
          this.messageEnd.current.scrollTo({
            top: height
          });
        }
      }, 100);
    } catch (e) {
      console.log('smswindow->scrollToBottom->', e);
    }
  };

  render_sms = () => {
    const singleTick = 'https://images.myyogateacher.com/icons/single-sent-tick.svg';
    const doubleTick = 'https://images.myyogateacher.com/icons/grey-read-tick.svg';
    const blueTick = 'https://images.myyogateacher.com/web_images/double_tick.svg';

    const statusImages = [singleTick, doubleTick, blueTick];
    const { iana_timezone } = this.props;

    const groupedMessages = this.state.sms_data_of_user.reduce((groups, message) => {
      const date = moment(message.sms_timestamp).format('YYYY-MM-DD');
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(message);
      return groups;
    }, {});

    const sortedDates = Object.keys(groupedMessages).sort((a, b) => moment(a).diff(moment(b)));

    const getDateHeader = (date) => {
      const today = moment().tz(this.props.iana_timezone).format('YYYY-MM-DD');
      const yesterday = moment()
        .tz(this.props.iana_timezone)
        .subtract(1, 'days')
        .format('YYYY-MM-DD');

      if (date === today) {
        return 'Today';
      } else if (date === yesterday) {
        return 'Yesterday';
      } else {
        return moment(date).tz(this.props.iana_timezone).format('DD MMM YYYY');
      }
    };

    return (
      <div className="c-c-messages" ref={this.messageEnd}>
        {sortedDates.map((date) => (
          <React.Fragment key={date}>
            <div className="text-center my-4">
              <div className="text-[var(--text-muted)] text-xs rounded-full flex items-center gap-2.5 leading-[15px] font-medium justify-center">
                <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex "></span>
                {getDateHeader(date)}
                <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex"></span>
              </div>
            </div>
            {groupedMessages[date].map((sms) => {
              let timeDisplay = '--:--';
              if (sms?.sms_timestamp && iana_timezone && moment(sms.sms_timestamp).isValid()) {
                timeDisplay = moment(sms.sms_timestamp).tz(iana_timezone).format('HH:mm');
              }

              return (
                <div className={sms.to_student == 1 ? 'my-sms' : 'friend-sms'} key={sms.uuid}>
                  <div
                    className="chat-cmt-box"
                    style={{
                      background:
                        sms.to_student == 1 ? 'var(--state-info-bg)' : 'var(--surface-sunken)',
                      color: 'var(--text-primary)'
                    }}
                  >
                    {Array.isArray(sms.media) &&
                    sms.media.length > 0 &&
                    Object.keys(sms.media[0]).length > 0 ? (
                      <SharedMediaRenderer sms={sms} />
                    ) : (
                      ''
                    )}
                    <br />
                    <span>{sms.sms_body}</span>
                    <div className={sms.to_student == 1 ? 'sms-time chat-me' : 'sms-time'}>
                      <div>{timeDisplay}</div>
                      <div className="flex gap-2">
                        <div>
                          {sms.message_type === 'whatsapp' ? <WhatsappIcon /> : <SMSIcon />}
                        </div>
                        <div>{sms.sender_name}</div>
                      </div>
                      <div>
                        {sms.to_student === 1 && sms.status >= 0 && sms.status <= 2 && (
                          <img
                            src={statusImages[sms.status]}
                            alt={`Status ${sms.status}`}
                            width="20"
                            height="20"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={sms.to_student == 1 ? 'flex justify-end' : 'flex justify-start'}>
                    {this.props.enable_reminder ? (
                      <button
                        type="button"
                        onClick={() => this.open_reminder(sms)}
                        className="mt-1 text-xs text-blue-600 hover:underline"
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: 0,
                          cursor: 'pointer'
                        }}
                      >
                        + Create reminder
                      </button>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </React.Fragment>
        ))}
        {this.render_scheduled_msgs()}
      </div>
    );
  };

  // Ghost bubbles for messages queued to send later — right-aligned like
  // outgoing messages, dashed border, with the send time and a cancel action.
  render_scheduled_msgs = () => {
    const { scheduled_msgs } = this.state;
    if (!scheduled_msgs.length) {
      return null;
    }

    return (
      <>
        <div className="text-center my-4">
          <div className="text-[var(--text-muted)] text-xs rounded-full flex items-center gap-2.5 leading-[15px] font-medium justify-center">
            <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex"></span>
            Scheduled
            <span className="w-full max-w-[140px] bg-[var(--border-default)] h-[1px] flex"></span>
          </div>
        </div>
        {scheduled_msgs.map((item) => {
          const tz = item.student_iana_timezone || this.props.student_iana_timezone;
          const at = tz ? moment.utc(item.scheduled_at).tz(tz) : moment.utc(item.scheduled_at);
          return (
            <div className="my-sms" key={item.uuid}>
              <div className="chat-cmt-box sched-bubble">
                <span>{item.content}</span>
                <div className="sched-bubble-meta">
                  <span>⏱ Sends {at.format('DD MMM, h:mm A')} (student time)</span>
                  <button
                    type="button"
                    className="sched-bubble-cancel"
                    onClick={() => this.cancel_scheduled_msg(item)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  toggle_message_type = () => {
    this.setState({ is_whatsapp: !this.state.is_whatsapp, predefined_msg: false });
  };

  render_header = () => {
    const { is_whatsapp, student_name } = this.state;
    const { message_dispatch_method, close_fn, is_allowed_whatsapp, is_allowed_sms } = this.props;
    return (
      <div className="c-c-header">
        <div className="c-c-header-c">
          <div className="flex items-center justify-between w-full">
            <span>{student_name}</span>
            {message_dispatch_method !== 'none' && is_allowed_whatsapp && is_allowed_sms ? (
              <div>
                <ToggleSwitch enabled={is_whatsapp} setEnabled={this.toggle_message_type} />{' '}
                {is_whatsapp ? 'WA' : 'SMS '}
              </div>
            ) : null}
            <div></div>
          </div>
        </div>
        <div className="c-c-header-i">
          <button className="chat-c-btn last-btn" onClick={close_fn}>
            <img
              className="close_min_chat"
              src="https://images.myyogateacher.com/ic_cross_ch1.svg"
              alt="c"
            />
          </button>
        </div>
      </div>
    );
  };

  render_predefined_message_btn = () => {
    const { selected_template } = this.state;
    return (
      <div
        className="btn btn-primary cursor-pointer w-full text-13.5px h-38px"
        onClick={() => {
          selected_template !== null
            ? this.reply_user('whatsapp', selected_template)
            : this.openPredefinedMessage();
        }}
      >
        {selected_template !== null ? 'Send predefined message' : 'Select predefined message'}
      </div>
    );
  };

  checkForWhatsapPredefinedMessage = () => {
    const { is_whatsapp } = this.state;
    if (!this.isAnyMessageSentByStudent() && is_whatsapp) {
      return true;
    }
  };

  toggle_force_instant = () => {
    this.setState((prev) => ({
      force_instant: !prev.force_instant,
      // Mutually exclusive with schedule-for-later.
      schedule_open: false,
      schedule_datetime: '',
      schedule_confirmed: false
    }));
  };

  toggle_schedule = () => {
    this.setState((prev) => ({
      schedule_open: !prev.schedule_open,
      // Opening pre-fills tomorrow 10 AM (student local time); closing clears.
      schedule_datetime: prev.schedule_open ? '' : this.default_schedule_datetime(),
      schedule_confirmed: false,
      force_instant: false
    }));
  };

  // Default schedule time: tomorrow 10:00 AM on the student's clock. Empty
  // when that falls outside the WhatsApp 24h reply window, so the agent must
  // pick a time within it.
  default_schedule_datetime = () => {
    const tz = this.props.student_iana_timezone;
    const t = (tz ? moment().tz(tz) : moment())
      .add(1, 'day')
      .set({ hour: 10, minute: 0, second: 0, millisecond: 0 });
    const wall_clock = t.format('YYYY-MM-DDTHH:mm');
    const max = this.schedule_max_date();
    if (max && moment(wall_clock).toDate() > max) {
      return '';
    }
    return wall_clock;
  };

  // Epoch (ms) when the WhatsApp 24h reply window closes, or null when there
  // is no inbound WhatsApp message. Same rule as render_timer/startTimer.
  whatsapp_window_expiry = () => {
    const msgs = this.state.sms_data_of_user || [];
    const last = [...msgs]
      .reverse()
      .find((m) => m.to_student === 0 && m.message_type === 'whatsapp');
    return last ? last.sms_epoch_time + 24 * 60 * 60 * 1000 : null;
  };

  is_whatsapp_composer = () =>
    this.props.message_dispatch_method === 'whatsapp' && this.state.is_whatsapp;

  // Converts an instant to the student's local wall-clock as a Date —
  // that's the clock the picker and schedule_at represent.
  as_student_wall_clock = (instant) => {
    const tz = this.props.student_iana_timezone;
    const m = tz ? moment(instant).tz(tz) : moment(instant);
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute());
  };

  // Earliest allowed schedule time: "now" in the student's local wall-clock.
  schedule_min_date = () => this.as_student_wall_clock(Date.now());

  // Latest allowed schedule time for WhatsApp (24h reply window expiry).
  // null = no cap (SMS, or no active WhatsApp window).
  schedule_max_date = () => {
    if (!this.is_whatsapp_composer()) {
      return null;
    }
    const expiry = this.whatsapp_window_expiry();
    return expiry ? this.as_student_wall_clock(expiry) : null;
  };

  // Returns an error message when the picked schedule time is unusable,
  // null when it's valid. Shared by OK-confirm and the send button.
  validate_schedule_time = () => {
    if (!this.state.schedule_datetime) {
      return 'Pick a date and time to schedule the message, or cancel scheduling.';
    }
    const picked = moment(this.state.schedule_datetime).toDate();
    if (picked <= this.schedule_min_date()) {
      return 'Schedule time must be in the future (student local time).';
    }
    const max = this.schedule_max_date();
    if (max && picked > max) {
      return `WhatsApp messages can only be scheduled within the 24-hour reply window — pick a time before ${moment(max).format('DD MMM, HH:mm')} (student local time).`;
    }
    return null;
  };

  confirm_schedule = () => {
    const schedule_error = this.validate_schedule_time();
    if (schedule_error) {
      this.props.set_notification_variable(true, 'error', schedule_error);
      return;
    }
    this.setState({ schedule_confirmed: true });
  };

  edit_schedule = () => this.setState({ schedule_confirmed: false });

  // Quiet hours = 10 PM–8 AM in the student's local timezone. Mirrors the
  // server-side gate; used only to decide whether to offer the instant-send
  // override. Falls back to "not in quiet hours" when the timezone is unknown.
  is_student_in_quiet_hours = () => {
    const tz = this.props.student_iana_timezone;
    if (!tz) {
      return false;
    }
    const hour = moment().tz(tz).hour();
    return hour >= 22 || hour < 8;
  };

  // When a quiet-hours message will actually go out: the next 10:00 AM on the
  // student's clock (today if it's the early-morning part of the window,
  // tomorrow if it's past 10 PM). Mirrors utils.NextQuietHoursSendTime.
  quiet_hours_send_time = () => {
    const tz = this.props.student_iana_timezone;
    const now = tz ? moment().tz(tz) : moment();
    const send_at = now.clone().set({ hour: 10, minute: 0, second: 0, millisecond: 0 });
    if (now.hour() >= 22) {
      send_at.add(1, 'day');
    }
    return send_at;
  };

  // The quiet-hours deferral is subject to the same 24h WhatsApp cap as the
  // explicit picker: a free-text message parked until 10 AM is dropped at
  // dispatch if the window closes first (PROD-8627). Returns an error message
  // when that's the case, null otherwise.
  quiet_hours_window_error = (message_tag = '') => {
    // Approved templates may be sent outside the window.
    if (message_tag !== '' || !this.is_whatsapp_composer()) {
      return null;
    }
    if (!this.is_student_in_quiet_hours() || this.state.force_instant) {
      return null;
    }
    const expiry = this.whatsapp_window_expiry();
    const send_at = this.quiet_hours_send_time();
    if (expiry && expiry > send_at.valueOf()) {
      return null;
    }
    const when = send_at.format('DD MMM, HH:mm');
    if (!expiry) {
      return `This student has not replied on WhatsApp, so a free-text WhatsApp message cannot be scheduled. Use a predefined template, send it as SMS, or tick "Send instantly".`;
    }
    return `The student is in quiet hours, so this would be sent at ${when} (student local time) — after the 24-hour WhatsApp reply window closes at ${moment(this.as_student_wall_clock(expiry)).format('DD MMM, HH:mm')}. Send instantly, use a predefined template, or send it as SMS.`;
  };

  // Warns before the agent hits send that a free-text WhatsApp message would
  // be deferred past the end of the 24h reply window.
  render_quiet_hours_warning = () => {
    const warning = this.quiet_hours_window_error();
    if (!warning) {
      return null;
    }
    return (
      <div
        className="mx-2 mb-1 rounded px-2 py-1 text-xs"
        style={{
          background: 'var(--state-warning-bg)',
          color: 'var(--state-warning-text)',
          border: '1px solid var(--state-warning)'
        }}
      >
        {warning}
      </div>
    );
  };

  render_dispatch_options = () => {
    const { force_instant, schedule_open, schedule_datetime, schedule_confirmed } = this.state;
    const schedule_min = this.schedule_min_date();
    const schedule_max = this.schedule_max_date();
    return (
      <div
        className="flex items-center flex-wrap gap-3 px-2 py-1 text-xs"
        style={{ color: 'var(--text-muted)' }}
      >
        {this.is_student_in_quiet_hours() && !schedule_open ? (
          <label className="flex items-center gap-1 cursor-pointer">
            <input type="checkbox" checked={force_instant} onChange={this.toggle_force_instant} />
            Send instantly (skip quiet hours)
          </label>
        ) : null}
        {!schedule_open ? (
          <button
            type="button"
            onClick={this.toggle_schedule}
            className="hover:underline"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              color: 'var(--brand-primary)'
            }}
          >
            Schedule for later
          </button>
        ) : schedule_confirmed ? (
          <span
            className="flex items-center gap-2 rounded-full px-2 py-0.5"
            style={{
              background: 'var(--state-info-bg)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-default)'
            }}
          >
            Sending at {moment(schedule_datetime).format('DD MMM YYYY, HH:mm')} (student local time)
            <button
              type="button"
              onClick={this.edit_schedule}
              className="hover:underline"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'var(--brand-primary)'
              }}
            >
              Change
            </button>
            <button
              type="button"
              onClick={this.toggle_schedule}
              aria-label="Cancel schedule"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'var(--state-error)'
              }}
            >
              ✕
            </button>
          </span>
        ) : (
          <span className="flex items-center gap-1">
            <DatePicker
              selected={schedule_datetime ? moment(schedule_datetime).toDate() : null}
              onChange={(date) =>
                this.setState({
                  schedule_datetime: date ? moment(date).format('YYYY-MM-DDTHH:mm') : ''
                })
              }
              showTimeSelect
              timeIntervals={15}
              // Bounds are in the student's local wall-clock: no past times
              // ("now" student-side), and for WhatsApp no times beyond the
              // 24h reply-window expiry.
              minDate={schedule_min}
              maxDate={schedule_max || undefined}
              filterTime={(t) =>
                t.getTime() > schedule_min.getTime() &&
                (!schedule_max || t.getTime() <= schedule_max.getTime())
              }
              dateFormat="dd MMM yyyy, h:mm aa"
              placeholderText="Pick date & time"
              shouldCloseOnSelect={false}
              popperPlacement="top-start"
            >
              <div
                className="flex items-center justify-end gap-2 w-full px-2 py-1"
                style={{ borderTop: '1px solid var(--border-default)' }}
              >
                <button
                  type="button"
                  onClick={this.toggle_schedule}
                  className="hover:underline"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '2px 6px',
                    cursor: 'pointer',
                    color: 'var(--text-muted)'
                  }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={this.confirm_schedule}
                  disabled={!schedule_datetime}
                  className="rounded px-3 py-0.5"
                  style={{
                    background: schedule_datetime
                      ? 'var(--brand-primary)'
                      : 'var(--border-default)',
                    color: '#fff',
                    border: 'none',
                    cursor: schedule_datetime ? 'pointer' : 'not-allowed'
                  }}
                >
                  OK
                </button>
              </div>
            </DatePicker>
            {schedule_max
              ? `(student local time · WhatsApp window closes ${moment(schedule_max).format('DD MMM, HH:mm')})`
              : '(student local time)'}
            <button
              type="button"
              onClick={this.toggle_schedule}
              className="hover:underline"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                color: 'var(--text-muted)'
              }}
            >
              Cancel
            </button>
          </span>
        )}
      </div>
    );
  };

  render_footer = () => {
    if (this.checkForWhatsapPredefinedMessage()) {
      return <div className="c-c-i-c">{this.render_predefined_message_btn()}</div>;
    }

    const { is_whatsapp, timeLeft, new_sms, schedule_open, schedule_datetime } = this.state;
    const { is_allowed_whatsapp, is_allowed_sms, message_dispatch_method } = this.props;

    return (
      <div className="c-c-i-c">
        {message_dispatch_method !== 'whatsapp' ||
        !is_whatsapp ||
        (timeLeft !== '00:00:00' && this.isAnyMessageSentByStudent()) ? (
          <div className="w-full">
            {this.render_quiet_hours_warning()}
            {this.render_dispatch_options()}
            <div className="composer-row">
              <div className="textarea-cont">
                <textarea
                  className="textarea"
                  value={new_sms}
                  name="new_sms"
                  rows={1}
                  ref={this.composerRef}
                  onChange={this.on_composer_change}
                />
              </div>
              <button
                type="button"
                className={`composer-send-btn ${
                  message_dispatch_method !== 'none' && is_whatsapp ? 'whatsapp_bg' : 'sms_bg'
                }`}
                onClick={() =>
                  this.reply_user(
                    message_dispatch_method === 'whatsapp' && is_whatsapp ? 'whatsapp' : 'sms'
                  )
                }
              >
                {schedule_open && schedule_datetime
                  ? 'Schedule'
                  : message_dispatch_method !== 'none' && is_whatsapp
                    ? 'Send WA'
                    : 'Send SMS'}
              </button>
            </div>
          </div>
        ) : (
          this.render_predefined_message_btn()
        )}
      </div>
    );
  };

  startTimer = () => {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    const message = this.state.sms_data_of_user;

    const lastMessageToStudent = [...message].reverse().find((msg) => msg.to_student === 0);

    let createdTime = Date.now();
    if (lastMessageToStudent) {
      createdTime = lastMessageToStudent.sms_epoch_time;
    }

    const expirationTime = createdTime + 24 * 60 * 60 * 1000;

    const updateTimer = () => {
      const currentTime = Date.now();
      const remainingTime = expirationTime - currentTime;

      if (remainingTime <= 0) {
        this.setState({
          timeLeft: '00:00:00',
          is_loading: false
        });
        clearInterval(this.timerInterval);
        return;
      }

      const hours = Math.floor(remainingTime / (1000 * 60 * 60));
      const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      this.setState({
        timeLeft: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
        is_loading: false
      });
    };

    updateTimer();
    this.timerInterval = setInterval(updateTimer, 1000);
  };

  handleSelectMessage = (message: string) => {
    this.setState({ selected_template: message });
  };

  render() {
    return this.state.is_loading ? (
      <CustomLoading />
    ) : (
      <div className="sms-window ch_new" ref={this.windowRef}>
        {this.render_header(this.state.student_name)}
        <div className="c-c-content">
          {this.render_timer()}
          {this.render_sms()}
          {this.render_footer()}
          {this.state.predefined_msg ? (
            <PredefinedMessage
              onSelect={this.handleSelectMessage}
              onSend={(tag) => this.reply_user('whatsapp', tag)}
              studentUUID={this.props.student_uuid}
              onClose={this.closePredefinedModal}
            />
          ) : null}
        </div>
        {this.state.sending_sms ? <CustomLoading full_loader={true} /> : null}
        {this.state.reminder_open ? (
          <RemindersModal
            show={this.state.reminder_open}
            close={this.close_reminder}
            openFormOnMount
            initialDescription={this.state.reminder_desc}
            defaultAssigneeUuid={this.props.reminder_assignee_uuid}
            linked_user={{
              uuid: this.props.student_uuid,
              name: this.state.student_name,
              type: 'student',
              role: 'student',
              iana_timezone: this.props.student_iana_timezone || this.props.iana_timezone || ''
            }}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    iana_timezone: state.home.iana_timezone
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_notification_variable: (show, type, mes) => {
      dispatch(actions.set_notification_variable(show, type, mes));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SmsWindow);
